import { useRef, useState } from "react";
import { uploadPdf } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X, Loader2, Check } from "lucide-react";

export function PdfUpload({ label, hint, value, onChange, testid }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const isPdf = (file.type || "").includes("pdf") || file.name.toLowerCase().endsWith(".pdf");
    if (!isPdf) { toast.error("Only PDF files are allowed."); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error("File is too large. Max 5MB."); return; }
    setBusy(true);
    try {
      const doc = await uploadPdf(file);
      onChange(doc);
      toast.success(`${doc.name} uploaded`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    }
    setBusy(false);
    e.target.value = "";
  };

  return (
    <div>
      {label && <label className="text-sm font-medium text-ink block">{label}</label>}
      {hint && <p className="text-xs text-mute mb-1">{hint}</p>}
      <input ref={inputRef} type="file" accept="application/pdf" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      {value?.path ? (
        <div className="mt-1 flex items-center gap-2 border border-line rounded-lg px-3 py-2 bg-bone/40">
          <Check className="h-4 w-4 text-forest shrink-0" />
          <span className="text-sm text-ink truncate flex-1">{value.name}</span>
          <button type="button" onClick={() => onChange(null)} data-testid={`${testid}-remove`} className="text-mute hover:text-red-600"><X className="h-4 w-4" /></button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="mt-1 w-full flex items-center justify-center gap-2 border border-dashed border-line rounded-lg px-3 py-2.5 text-sm text-mute hover:border-forest hover:text-forest transition-colors disabled:opacity-60"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {busy ? "Uploading…" : "Upload PDF (max 5MB)"}
        </button>
      )}
    </div>
  );
}
